<template>
  <v-card height="100%">
    <v-data-table
      :headers="headers"
      :items="clientSchools"
      sort-by="effectiveDate"
      sort-desc
      :item-class="formatCurrent"
    >
      <template v-if="canEdit" v-slot:[`top`]="{}">
        <v-row>
          <v-spacer></v-spacer>
          <client-school-form></client-school-form>
        </v-row>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <client-school-form
          v-if="!viewOnly"
          :clientSchool="item"
        ></client-school-form>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import ClientSchoolForm from "./client-school-form";
export default {
  components: { ClientSchoolForm },
  props: ["viewOnly"],
  data() {
    return {
      headers: [
        { text: "School Name", value: "school.schoolName" },
        { text: "School Contact", value: "school.contact" },
        { text: "Phone", value: "school.phone" },
        { text: "Effective Date", value: "formattedEffectiveDate" },
        { text: "End Date", value: "formattedEndDate" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    canEdit() {
      return (
        !this.viewOnly &&
        (this.$store.getters["securityModule/isEIAdmin"] ||
          this.$store.getters["securityModule/isSEITAdmin"])
      );
    },
    clientSchools() {
      return (
        this.$store.state.clientModule.selectedClient.clientSchools || null
      );
    },
  },
  methods: {
    formatCurrent(item) {
      let today = new Date();
      if (item.effectiveDate <= today && item.endDate >= today) {
        return "elevation-5";
      }
    },
  },
};
</script>
